import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import TouchButton from "../../atoms/TouchButton/TouchButton";
import InputSelect from "../../atoms/InputSelect/InputSelect";
import { QuestionProps } from "../../../types/components/molecules/questionProps";

const Heightth = ({ formData, setFormData, onValidationChange, mode = 'wizard' }: QuestionProps) => {
  const { t } = useTranslation();

  useEffect(() => {
    onValidationChange?.(formData.is_sterilized !== undefined);
  }, [formData.is_sterilized, onValidationChange]);

  if (mode === 'validation') {
    return (
      <InputSelect
        label={t("animalInfo:QUESTION_EIGHT.STERILIZATION_STATUS")}
        datas={[
          { value:"true", label: t("animalInfo:QUESTION_EIGHT.STERILIZED") },
          { value: "false", label: t("animalInfo:QUESTION_EIGHT.NOT_STERILIZED") },
        ]}
        value={formData.is_sterilized ? "true" : "false"}
        onChange={(event) => setFormData({ 
          ...formData, 
          is_sterilized: event.target.value === "true" 
        })}
      />
    );
  }

  return (
    <>
      <TouchButton
        text={t("animalInfo:QUESTION_EIGHT.YES")}
        active={formData.is_sterilized === true}
        onClick={() => {
          setFormData({ ...formData, is_sterilized: true });
        }}
      />
      <TouchButton
        text={t("animalInfo:QUESTION_EIGHT.NO")}
        active={formData.is_sterilized === false}
        onClick={() => {
          setFormData({ ...formData, is_sterilized: false });
        }}
      />
    </>
  );
};

export default Heightth;
